import { Controller } from '@hotwired/stimulus';
import { useInterval } from 'stimulus-library';

export default class TurboFrameRefreshController extends Controller {
  static values = {
    interval: Number,
    poll: Boolean,
  };

  get poll() {
    return this.hasPollValue ? this.pollValue : false;
  }

  connect() {
    if (this.poll) {
      useInterval(this, this.refresh, this.intervalValue);
    }
  }

  refresh(event) {
    if (event) {
      event.preventDefault();
    }
    this.element.reload();
  }
}
